import { Component } from '@angular/core';

@Component({
    selector: 'w-li-button',
    templateUrl: './w-li-button.component.html',
    host: {
        role: 'listitem',
        class: 'b-workbench-filter__tab b-tablist__tab',
        tabindex: '-1'
    },
    standalone: false
})
export class WLiButtonComponent { }
